import React, { useState, useEffect, useContext } from "react";
import toastr from "toastr";
import { TextField, Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { appContext } from "../App";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { addIssuerType } from "../Api/api";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  textField: {
    width: "184px",
  },
}));

const AddIssuerTypeModal = (props) => {
  const { authUser, setAuthUser } = useContext(appContext);
  const [issuerType, setIssuerType] = useState("");

  useEffect(() => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: false,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
  }, []);

  const handleChange = (event) => {
    event.persist();
    setIssuerType(event.target.value);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (authUser && authUser.uuid) {
      addIssuerType({ issuerType: issuerType })
        .then((response) => {
          if (response && response.status === 201) {
            props.onCloseModal();
            toastr.success("Created Issuer Type successfully !");
          }
        })
        .catch((error) => toastr.error(error));
    }
  };

  const resetStateAndClose = (event) => {
    event.preventDefault();
    setIssuerType("");
    props.onCloseModal();
  };

  return (
    <div>
      <Dialog
        open={props.openModal}
        onClose={(event) => resetStateAndClose(event)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add Issuer Type</DialogTitle>
        <DialogContent style={{ width: "500px" }}>
          <DialogContentText id="alert-dialog-description">
            <Grid item xs={12}>
              <TextField
                type="text"
                name="organizationName"
                variant="outlined"
                fullWidth
                label="Issuer Type"
                defaultValue={issuerType}
                onChange={(event) => handleChange(event)}
              />
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => resetStateAndClose(event)}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={(event) => submitHandler(event)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddIssuerTypeModal;
